import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackMetaPageView } from '@/utils/loadTrackingPixels';

/**
 * Dispara un PageView de Meta por cada navegación real de React Router.
 *
 * - La ruta privada (/admin, /client) se ignora dentro del tracker.
 * - La deduplicación por ruta vive en el tracker, así que un re-render
 *   o el doble montaje de StrictMode no genera PageViews extra.
 */
export function useMetaPixelPageViews(): void {
  const { pathname } = useLocation();

  useEffect(() => {
    void trackMetaPageView(pathname);
  }, [pathname]);
}

export default useMetaPixelPageViews;